

const BlockStyleButton = (props) => {

    const onToggle = e => {
        e.preventDefault();
        props.onToggle(props.style);
    };

    let className = "RichEditor-styleButton";
    if (props.active) {
        className += " RichEditor-activeButton";
    }

    return (
        <div className={props.icon} onClick={onToggle}/>
    )

}

export default BlockStyleButton;